<template>
  <VListItem
    v-if="showAppSwitcher"
    class="text-decoration-none pl-2"
    prepend-icon="$twi-app-switcher"
    :title="t('navigationMenu.teamworksApps')"
    data-testid="navigationAppSwitcherMenu"
    link
    aria-haspopup="menu"
    role="button"
  >
    <AppSwitcherMenu
      v-model="isAppSwitcherMenuOpen"
      :app-switcher="appSwitcher"
      activator="parent"
      theme="TwLight"
    />
    <VTooltip
      v-if="!isExpanded"
      activator="parent"
      location="right"
      :aria-label="t('navigationMenu.teamworksApps')"
    >
      {{ t('navigationMenu.teamworksApps') }}
    </VTooltip>
  </VListItem>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { AppSwitcherMenu } from '@teamworksdev/vuetify';
import { useAppSwitcher } from '@/composables/useAppSwitcher';

const { isExpanded = true } = defineProps<{
  isExpanded: boolean;
}>();

const { t } = useI18n();

const isAppSwitcherMenuOpen = ref(false);

const appSwitcher = useAppSwitcher();

const showAppSwitcher = computed(() => appSwitcher.value.appList.length > 1);
</script>
